import styled from "styled-components";

export const InlineValueSlot = styled.span`
  display: inline-flex;
  align-items: center;
  min-height: 22px;
`;
